import script from "./RefreshTokenComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefreshTokenComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__